import {helpers, required, requiredIf} from "@vuelidate/validators";
import {EXTERNAL_APPEALS_HEALTH_INSURANCE_COMPANIES} from "@/utils/constants.js";

export class ExternalAppealHealthPlanModel {
    constructor(data = {}) {
        this.healthPlanId = data.healthPlanId ?? null;
        this.appealId = data.appealId ?? null;
        this.healthInsuranceCompany = data.healthInsuranceCompany ?? null;
        this.otherHmoName = data.otherHmoName ?? null;
        this.patientInsuranceId = data.patientInsuranceId ?? null;
        this.typeOfCoverage = data.typeOfCoverage ?? null;
        this.otherTypeOfCoverage = data.otherTypeOfCoverage ?? null;
        this.createdAt = data.createdAt ?? null;
        this.updatedAt = data.updatedAt ?? null;
    }

    toRequestPayload() {
        return {
            healthPlanId: this.healthPlanId,
            appealId: this.appealId,
            healthInsuranceCompany: this.healthInsuranceCompany,
            otherHmoName: this.otherHmoName,
            patientInsuranceId: this.patientInsuranceId,
            typeOfCoverage: this.typeOfCoverage,
            otherTypeOfCoverage: this.otherTypeOfCoverage,
            createdAt: this.createdAt,
            updatedAt: this.updatedAt
        };
    }

}
